import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";

/**
 * Dialog shown when the user tries to add a word that is already placed in the puzzle grid.
 * Used by cross board (Manual / AI Associations) and grid board candidates.
 */
export default function WordAlreadyPlacedDialog({ open, onClose, word }) {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            aria-labelledby="already-placed-dialog-title"
        >
            <DialogTitle id="already-placed-dialog-title">Word Already in Grid</DialogTitle>
            <DialogContent>
                <Typography>
                    This &quot;{word}&quot; word is already placed in the puzzle.
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary" variant="contained">
                    OK
                </Button>
            </DialogActions>
        </Dialog>
    );
}
